import server from "@/plugins/http.js";
// 重启云手机
export function commandreboot(data) {
    return server({
        url: '/api/app/command/reboot',
        method: 'post',
        data: data,
    })
}

// 恢复出厂设置
export function commandreset(data) {
    return server({
        url: '/api/app/command/reset',
        method: 'post',
        data: data,
    })
}
// 修改名称
export function instanceupdate(data) {
    return server({
        url: '/api/app/instance/update',
        method: 'post',
        data: data,
    })
}
// 一键新机
export function commandnewPad(data) {
    return server({
        url: '/api/app/command/newPad',
        method: 'post',
        data: data,
    })
}
// 更换设备
export function instancechange(id) {
    return server({
        url: '/api/app/instance/change/' + id,
        method: 'post',
    })
}

// 获取一键新机品牌型号
export function phoneModelList(params) {
    return server({
        url: 'api/admin/app/instance/phoneModelList',
        method: 'get',
        params: params
    })
}

// 批量重命名
export function rename(data) {
    return server({
        url: '/api/app/instance/rename',
        method: 'post',
        data: data,
    })
}

// 新增分组
export function groupAdd(data) {
    return server({
        url: '/api/app/group/add',
        method: 'post',
        data: data,
    })
}
// 新增分组
export function groupUpdate(data) {
    return server({
        url: '/api/app/group/update',
        method: 'post',
        data: data,
    })
}
// 删除分组
export function groupDelete(data) {
    return server({
        url: '/api/app/group/delete',
        method: 'post',
        data: data,
    })
}
// 移动分组
export function groupInstance(data) {
    return server({
        url: '/api/app/group/move/instance',
        method: 'post',
        data: data,
    })
}
// 设备转移
export function userEquipmentTransfer(data) {
    return server({
        url: '/api/app/instance/userEquipmentTransfer',
        method: 'post',
        data: data,
    })
}
// 获取可用设备列表
export function authorizeinstancelist(params) {
    return server({
        url: '/api/app/authorize/instance/list',
        method: 'get',
        params: params
    })
}
// 用户授权
export function authorize(data) {
    return server({
        url: '/api/app/authorize',
        method: 'post',
        data: data,
    })
}
// 授权记录列表
export function authorizerecordlist(params) {
    return server({
        url: '/api/app/authorize/record/list',
        method: 'get',
        params: params
    })
}
// 取消授权
export function authorizemanage(data) {
    return server({
        url: '/api/app/authorize/v2/manage',
        method: 'post',
        data: data,
    })
}
// 获取serverToken
export function serverToken(data) {
    return server({
        url: '/api/app/instance/serverToken',
        method: 'post',
        data: data,
    })
}